import { useSignal } from "@preact/signals-react";

export enum ChoosingFormat {
  AIAPP = "AIAPP",
  STATICWEBSITE = "STATICWEBSITE",
  AICHATAGENT = "AICHATAGENT",
  MOBILEAPP = "MOBILEAPP",
  THINKINGCANVAS = "THINKINGCANVAS",
  AUTOIMAGICA = "AUTOIMAGICA",
}

const useChoosingFormatState = () => {
  const chooseFormatValue = useSignal<ChoosingFormat | null>(null);

  return {
    chooseFormatValue,
  };
};

export default useChoosingFormatState;
